<div class="task-detail">
  <p class="sub-heading">
    @if(userEnum === UserRoleEnum.Admin) {
    {{"validationForm.taskDetails" | translate}}
    }@else{
    {{getConsultantLabel('taskDetails')}}
    }
  </p>
  <div class="d-flex flex-column gap-2">
    <div class="row">
      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"labels.customer" | translate}}
        }@else{
        {{getConsultantLabel('customer')}}
        }
      </p>
      <p class="col-7 label-value">{{taskDetails.customer}}</p>
    </div>
    <div class="row">
      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"labels.location" | translate}}
        }@else{
        {{getConsultantLabel('location')}}
        }</p>
      <p class="col-7 label-value">{{taskDetails.location}}</p>
    </div>
    <div class="row">
      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"labels.role" | translate}}
        }@else{
        {{getConsultantLabel('role')}}
        }
      </p>

      <div class="col-7 label-value">
        <app-content-translater class="label-value" [content]="consultantForTask" [selectedLang]="validationFormLang"
          [notBold]="true"></app-content-translater>
      </div>
    </div>
    <div class="row">

      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"labels.languageRequirement" | translate}}
        }@else{
        {{getConsultantLabel('languageRequirement')}}
        }

      </p>
      <p class="col-7 label-value">{{taskDetails.languageRequirement}}</p>
    </div>
    <div class="row">
      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"validationForm.startDate" | translate}}
        }@else{
        {{getConsultantLabel('startDate')}}
        }</p>
      <p class="col-7 label-value">{{taskDetails.startDate | date : dateFormatEnum.OnlyDate}}</p>
    </div>
    <div class="row">
      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"validationForm.endDate" | translate}}
        }@else{
        {{getConsultantLabel('endDate')}}
        }
      </p>
      <p class="col-7 label-value">{{taskDetails.endDate | date : dateFormatEnum.OnlyDate}}</p>
    </div>
    <div class="row">
      <p class="col-5 label-title">
        @if(userEnum === UserRoleEnum.Admin) {
        {{"validationForm.timePerWeek" | translate}}
        }@else{
        {{getConsultantLabel('timePerWeek')}}
        }
      </p>
      <p class="col-7 label-value">{{taskDetails.hours}}</p>
    </div>
  </div>
  <div class="quill-task-desc">
    <p class="col-5 label-title">
      @if(userEnum === UserRoleEnum.Admin) {
      {{"validationForm.taskDescription" | translate}}
      }@else{
      {{getConsultantLabel('taskDescription')}}
      }
    </p>
    <div >

    @if(!showMore && taskDetails.description.length > 200) {
    <!-- <p class="label-value">{{ taskDetails.description.slice(0, 150) }}...</p> -->
       <quill-view [content]=" taskDetails.description.slice(0, 200)" class="quill-view"></quill-view>
    }@else {
    <!-- <p class="label-value">{{formTaskDescripion ? formTaskDescripion : taskDetails.description }}</p> -->
               <quill-view [content]="formTaskDescripion ? formTaskDescripion : taskDetails.description" class="quill-view"></quill-view>


    }
    </div>

    @if(taskDetails.description.length > 150) {
      <span class="read-more label-value" (click)="toggleReadMore()">
        {{ (showMore ? 'labels.readLess' : 'labels.readMore') | translate }}
        <img
          [src]="'assets/icons/caret.svg'"
          alt="icon"
          class="ml-1"
          [style.transform]="showMore ? 'rotate(180deg)' : 'none'"
        />
      </span>
    }
  </div>
  <div>

@if (taskDetails.taskSkills.length > 0) {
  <p class="label-title">
    {{ "labels.competenceRequirements" | translate }}
  </p>
  <div class="task-skills-container">
    @for (taskSkill of taskDetails.taskSkills; track taskSkill.id) {
      <div class="task-skill">
        {{ taskSkill.skill }}
      </div>
    }
  </div>
}
  </div>
  <div>
    @if(paymentDetails) {
    <p class="sub-heading">
      @if(userEnum === UserRoleEnum.Admin) {
      {{"validationForm.paymentConditions" | translate }}

      }@else{
      {{getConsultantLabel('paymentConditions')}}
      }
    </p>
    <p class="col-7 label-value">{{paymentDetails}}</p>
    }

  </div>
</div>